import React, { useState } from "react";
import { tokens } from "../../theme/theme";
import { Divider, Typography, Card, CardContent, Grid, CardHeader, IconButton, Button, useTheme, Box, Badge, } from "@mui/material";

import { useTranslation } from "react-i18next";
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DescriptionIcon from '@mui/icons-material/Description';
import InsightsIcon from '@mui/icons-material/Insights';
import DashboardCard from "../../components/common/DashboardCard";

const SalesMenuIndex = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    const [xlValue,setXLValue]=useState(2);

    const callback = () => {
        handleBackDashboard();
    };

 return (
        <Box >


            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">Sales Management </Typography>
                    </Box>
                </CardContent>
            </Card>


            {/* <Divider /> */}
            <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="10px"  >

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>                     
                         <DashboardCard
                            title={t('sales.dispatch_plan')}
                            icon={<LocalShippingRoundedIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("Despatch List")}
                            subtitle="Update"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('sales.delivery_order')}
                            icon={<MoveToInboxIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("Delivery Order List")}
                            subtitle="Update"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('sales.invoice')}
                            icon={<ReceiptLongIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("Invoice List")}
                            subtitle="Update"
                        />
                    </Grid>

                    {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <Typography variant="h6" mt={2}>Report Templates</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ReportTemplates")}>Update</Button>
                        </Card>
                    </Grid> */}

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('sales.sales_report')}
                            icon={<InsightsIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("SalesReports")}
                            subtitle="Update"
                        />
                    </Grid>


                </Grid>
            </Box>
        </Box>

    )
}
export default SalesMenuIndex;